<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title" v-if="checkClientStar">
        {{ $t("Municipality Report") }}
      </div>
      <div class="section-title" v-else>
        {{ $t("gcamreport") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <!-- <b-dropdown
                :disabled="isRoleID"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="true"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label :class="filter_key_array.length > 0 ? 'shift-up' : ''"
                >{{ $t("Select ") }} {{ $tc("Filter", 1) }}</label
              >

              <multiselect
                :disabled="isRoleID"
                :options="filter_key_array"
                v-model="filter_value"
                :searchable="true"
                placeholder="Select Filter"
                :allowEmpty="true"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  @selected="onChangeDate($event, 'from')"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                  :disabledDates="{
                    from: new Date(
                      moment(fromDate).add(31, 'd').format('YYYY-MM-DD')
                    ),
                  }"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getGcamReportsExcel('N')"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            class="col-lg-12 col-xl-12 align-self-center mt-2 d-flex justify-content-end"
          >
            Download as :
            <!-- <img @click="ExportExcel('xlsx')" src="@/assets/img/icons/excel.svg" height="25" width="25" /> -->
            <span
              style="cursor: pointer"
              @click="getGcamReportsExcel('Y')"
              title="Download as Excel"
              download
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </span>
          </div>
        </div>
      </div>

      <div>
        <div class="table-scroll">
          <table class="swc-report-table" border="1">
            <thead>
              <tr>
                <th v-if="filter_value == 'Show Date'">Show Date</th>
                <th v-if="filter_value != 'Show Date'">Business Date</th>
                <th>Cinema Name</th>
                <th>Movie Name</th>
                <th>Ticket Class</th>
                <th :class="checkClientStar ? 'd-none' : ''">
                  Before VAT Ticket Price
                </th>

                <th>Class Rate</th>
                <th>Admits</th>
                <th>Total Selling Price</th>
                <th>VAT %</th>
                <th>VAT Amount</th>

                <th v-if="checkClientStar">Before M-Tax</th>
                <th v-else>Before VAT</th>
                <th v-if="checkClientStar">M-Tax %</th>
                <th v-else>GCAM %</th>
                <th v-if="checkClientStar">M-Tax Amount</th>
                <th v-else>GCAM Amount</th>
              </tr>
            </thead>
            <tbody v-if="getGcamReportList.length > 0">
              <tr
                v-for="(gcamData, gcamDataIndex) in getGcamReportList"
                :key="gcamDataIndex"
              >
                <td class="text-left" v-if="filter_value == 'Show Date'">
                  {{ gcamData.show_date }}
                </td>
                <td class="text-left" v-if="filter_value != 'Show Date'">
                  {{ gcamData.business_date }}
                </td>
                <th>
                  {{ gcamData.cinema_name }}
                </th>
                <!-- <td class="text-left">{{ gcamData.ss_start_date }}</td> -->
                <td class="text-left">
                  {{ gcamData.movie_name }}
                </td>
                <td class="text-left">{{ gcamData.seat_type_name }}</td>
                <td class="text-right" :class="checkClientStar ? 'd-none' : ''">
                  {{ currFormat3(gcamData.before_vat_ticket_price) }}
                </td>
                <td class="text-right">
                  {{ gcamData.class_rate }}
                </td>
                <td class="text-right">{{ gcamData.admits }}</td>
                <td class="text-right">
                  {{ currFormat3(gcamData.total_amount) }}
                </td>
                <td class="text-right">{{ gcamData.vat_percentage }}%</td>
                <td class="text-right">
                  {{ currFormat3(gcamData.VAT) }}
                </td>
                <td class="text-right">
                  {{ currFormat3(gcamData.before_vat) }}
                </td>
                <td class="text-right">{{ gcamData.gcam_percentage }}%</td>
                <td class="text-right">
                  {{ currFormat3(gcamData.GCAM) }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="13">
                  <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>

          <table
            class="swc-report-table"
            border="1"
            ref="gcam_table"
            v-if="false"
          >
            <template v-for="(gcamData, gcamDataIndex) in getGcamReportList">
              <tr
                :key="gcamDataIndex"
                :class="
                  gcamDataIndex == 0 ? 'bg-lightgrey font-weight-bold' : ''
                "
              >
                <td :rowspan="gcamData.movies.length + 1">
                  {{ gcamData.showDate }}
                </td>
                <td :rowspan="gcamData.movies.length + 1">
                  {{ gcamData.buisnessDate }}
                </td>
              </tr>
              <tr
                v-for="(movie, movieIndex) in gcamData.movies"
                :key="movieIndex"
                :class="[
                  gcamDataIndex == 0 ? 'bg-lightgrey font-weight-bold' : '',
                  String(movie.name).toLowerCase().includes('(total)')
                    ? 'font-weight-bold'
                    : '',
                ]"
              >
                <td
                  v-for="(movieObj, movieObjIndex) in Object.keys(movie)
                    .filter((x) => x != 'buisnessDate')
                    .filter((x) => x != 'showDate')"
                  :key="movieIndex"
                  :class="[
                    typeof movie[movieObj] == 'number'
                      ? 'text-right'
                      : 'text-left',
                  ]"
                >
                  {{
                    typeof movie[movieObj] == "number" &&
                    movieObj != "admits" &&
                    movieObj != "vatPercentage" &&
                    movieObj != "gcamPercentage"
                      ? movie[movieObj].toFixed(this.MIN_FRACTION_DIGITS)
                      : movie[movieObj]
                  }}
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService";
import NewReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import * as XLSX from "xlsx";
import { Role, CLIENT_NAME } from "@/helper/Role";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      isExcel: "N",
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      filter_key_array: ["Show Date", "Business Date"],
      filter_value: "Show Date",
      getGcamReportList: [],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    console.log(CinemaObj, "fsfsf");
    this.getCinemaList();
    if (CinemaObj) {
      if (CinemaObj.cine_id != "all") {
        this.onSelectCinema(CinemaObj);
      }
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        if (CinemaObj.cine_id != "all") {
          this.onSelectCinema(CinemaObj);
        }
      }
    },
  },
  computed: {
    checkClientStar() {
      console.log(this.CLIENT_SETUP_NAME, "Hello Client");
      return CLIENT_NAME.STAR == this.CLIENT_SETUP_NAME;
    },
  },
  mounted() {},
  methods: {
    moment,
    onChangeDate(e, type) {
      console.log("onChangeDate", type);
      if (type == "from") {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    getGcamReportsExcel(isExcel = "N") {
      this.submitted = true;
      this.getGcamReportList = [];

      if (!this.dropDown.selectedCinemaId) {
        this.$toasted.show(`Please Select Cinema`);
        return false;
      }

      let selectedCinemaId =
        this.dropDown.selectedCinemaId == 0
          ? this.CinemasCopy.map((x) => {
              return x.cine_id;
            })
          : [this.dropDown.selectedCinemaId];

      if (!this.fromDate) {
        return this.$toasted.show("From Date field cannot be empty");
      } else if (!this.toDate) {
        return this.$toasted.show("To Date field cannot be empty");
      } else if (moment(this.fromDate).isAfter(moment(this.toDate))) {
        return this.$toasted.show("To date should be greater than from date");
      }
      let loader = this.$loading.show();

      let payload = {
        cinema_id: selectedCinemaId[0] || "",
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        excel: isExcel,
        is_filter_show_date: this.filter_value == "Show Date",
      };
      NewReportsService.GetGcamNewExcel(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.getGcamReportList = [...data.Records];
          } else {
            this.$toasted.show(data.message);
          }
          if (data.excelUrl) {
            window.open(data.excelUrl, "_blank");
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError);
    },
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.gcam_table;
      var wb = XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(wb, fn || "GCAMReport." + (type || "xlsx"));
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            // let cinemas = [
            //   {
            //     cine_id: "all",
            //     cine_name: "All Cinemas",
            //   },
            // ];
            // if (data.Records.length == 1) {
            //   cinemas = [];
            // }
            this.dropDown.cinemas = [ ...data.Records];
            this.CinemasCopy = [ ...data.Records];
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      if (event.cine_id != "all") {
        this.$store.dispatch("selectDropdownCinema", event);
      }
    },
    getGcamReports: function (isExcel) {
      this.submitted = true;
      this.getGcamReportList = [];

      let selectedCinemaId =
        this.dropDown.selectedCinemaId == 0
          ? this.CinemasCopy.map((x) => {
              return x.cine_id;
            })
          : this.dropDown.selectedCinemaId;

      if (!this.fromDate) {
        return this.$toasted.show("From Date field cannot be empty");
      } else if (!this.toDate) {
        return this.$toasted.show("To Date field cannot be empty");
      } else if (moment(this.fromDate).isAfter(moment(this.toDate))) {
        return this.$toasted.show("To date should be greater than from date");
      }
      let loader = this.$loading.show();

      let payload = {
        cinema_id: selectedCinemaId || "",
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        excel: isExcel,
      };
      ReportsService.GetGcanReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.getGcamReportList = data.Records;
            if ((isExcel = "Y" && data.excelUrl)) {
              window.open(data.excelUrl, "_blank");
            }
            // console.log(
            //   "Latest Mapping",
            //   this.getGcamReportList.map((x, y) => {
            //     return [...x, x.movies.flat()].flat();
            //   })
            // );
          } else {
            return this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 500);
        });
    },
  },
  beforeDestroy: async function () {
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getGcamExcelFileName,
    });
    await this.onResetGcamReportStoreState();
  },
};
</script>

<style scoped>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/MuncipalityReport.vue